import { component as defineComponent } from 'flightjs';

var eliminateDesignerModal = function() {
    this.attributes({
        designerAvatar: '[data-eliminate-designer-modal-avatar-img]',
        designerNameSpan: '[data-eliminate-designer-modal-name-span]',
        eliminateForm: '[data-eliminate-designer-modal-form]',
    });

    this.after('initialize', function() {
        this.on(document, 'uiEliminateDesignerRequested', this.updateModalContent);
    });

    this.updateModalContent = function(event, data) {
        this.select('designerAvatar').attr('src', data.eliminateDesignerAvatar);
        this.select('designerNameSpan').text(data.eliminateDesignerName);
        this.select('eliminateForm').attr('action', data.eliminateDesignerUrl);
    };
};

export default defineComponent(eliminateDesignerModal);



// WEBPACK FOOTER //
// ./src/web/js/contest/ui/eliminate-designer-modal.js